import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=60d23e8e&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=60d23e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d23e8e",
  null
  
)

export default component.exports